/**
 * Central tuning file. All magic numbers live here so the rest of the code stays focused.
 */

export interface Product {
  id: string
  name: string
  img: string
  desc: string
  price: string
  badge?: string
}

export const PRODUCTS: Product[] = [
  {
    id: 'gelo-1kg',
    name: 'Gelo 1 kg',
    img: '/GELO1KG.webp',
    desc: 'Cubo cristal, perfeito para drinks, eventos e caixas térmicas.',
    price: 'A partir de R$ 5,00',
    badge: 'Mais pedido',
  },
  {
    id: 'gelo-3kg',
    name: 'Gelo 3 kg',
    img: '/Gelo3KG.webp',
    desc: 'Pacote família — ideal para churrascos e reuniões.',
    price: 'A partir de R$ 12,00',
  },
  {
    id: 'gelo-10kg',
    name: 'Gelo 10 kg',
    img: '/Gelo10KG.webp',
    desc: 'Atacado para bares, restaurantes e distribuidoras.',
    price: 'A partir de R$ 25,00',
  },
]

/** Puddle definitions in normalized viewport coordinates.
 *  Keep them in quiet areas of the background so fishing feels natural. */
export interface PuddleConfig {
  nx: number        // normalized x (0..1 of viewport)
  ny: number        // normalized y (0..1 of viewport)
  rx: number        // ellipse radius X (px)
  ry: number        // ellipse radius Y (px)
  fishCount: number // initial stock
}

export const PUDDLES: PuddleConfig[] = [
  { nx: 0.12, ny: 0.32, rx: 95,  ry: 30, fishCount: 2 },
  { nx: 0.82, ny: 0.58, rx: 120, ry: 36, fishCount: 3 },
  { nx: 0.42, ny: 0.78, rx: 105, ry: 32, fishCount: 2 },
  { nx: 0.88, ny: 0.22, rx: 85,  ry: 26, fishCount: 2 },
  { nx: 0.22, ny: 0.85, rx: 100, ry: 30, fishCount: 2 },
]

/** Particle counts — halved on mobile via env.isMobile. */
export const COUNTS = {
  snowDesktop: 120,
  snowMobile: 40,
  iceChunksDesktop: 8,
  iceChunksMobile: 4,
  maxFish: 14,
}

/** Ice / background palette values (mirror base.css tokens — keep in sync). */
export const PALETTE = {
  skyTop: '#070b18',
  skyBottom: '#0f2a3d',
  cyan: '#00f2fe',
  gold: '#ffd966',
  goldDeep: '#c69a2a',
  iceLight: '#d4f7ff',
  iceMid: '#9bdcf3',
  iceDark: '#4a9bbf',
  puddleDark: '#050a14',
  puddleRim: 'rgba(155, 220, 243, 0.6)',
}

/** Score & localStorage keys. */
export const STORAGE = {
  fishCountKey: 'diskgelo:fish-count',
  praiseShownKey: 'diskgelo:praise-shown',
}

/** Milestones for praise toasts. */
export const MILESTONES = [5, 15, 30]
